import type { TFunction } from "i18next";

import type { OrderLineVideo, OrderScriptRow } from "../types/marketplace.types";

export function orderLineVideos(script: OrderScriptRow): OrderLineVideo[] {
  return [...(script.videos ?? [])].sort(
    (left, right) => left.position - right.position,
  );
}

export function isOrderLineVideoSlotEmpty(
  video: Pick<
    OrderLineVideo,
    "isEmpty" | "preflightUploadId" | "scriptReviewId" | "preflightUrl"
  >,
): boolean {
  return (
    video.isEmpty === true ||
    (video.preflightUploadId === null &&
      video.scriptReviewId === null &&
      !video.preflightUrl?.trim())
  );
}

/** Uploaded videos only — use for counts/chips; ops tree lists all slots via `orderLineVideos`. */
export function filledOrderLineVideos(script: OrderScriptRow): OrderLineVideo[] {
  return orderLineVideos(script).filter(
    (video) => !isOrderLineVideoSlotEmpty(video),
  );
}

export function orderLineVideoKey(video: OrderLineVideo): string {
  return video.id ?? `position-${video.position}`;
}

export function scriptHasExpandableVideos(script: OrderScriptRow): boolean {
  return orderLineVideos(script).length > 0;
}

export function orderLineVideoDisplayName(
  video: Pick<OrderLineVideo, "position" | "label">,
  t: TFunction,
): string {
  const custom = video.label?.trim();
  if (custom) return custom;
  return t("marketplace.partner.videos.videoLabel", {
    number: video.position + 1,
    defaultValue: "Video {{number}}",
  });
}

export function orderLineVideoLabelEditable(video: OrderLineVideo): boolean {
  return video.id !== null;
}
